/**
 * Created by seaasun on 2017/12/20.
 */

import app from '@/main.js'
import { TerraDraw, TerraDrawPolygonMode } from 'terra-draw'
import { TerraDrawGoogleMapsAdapter } from 'terra-draw-google-maps-adapter'

export default (id, options) => {
  /* eslint-disable no-undef */
  let googleMap = google.maps
  googleMap.Polygon.prototype.getBounds = function () {
    let bounds = new googleMap.LatLngBounds()
    let paths = this.getPaths()
    let path
    for (var i = 0; i < paths.getLength(); i++) {
      path = paths.getAt(i)
      for (var ii = 0; ii < path.getLength(); ii++) {
        bounds.extend(path.getAt(ii))
      }
    }
    return bounds
  }
  if (document.getElementById(id) === null) {
    return false
  }
  let map = new googleMap.Map(document.getElementById(id), options)
  let x = null
  let polygon = null
  let address = null
  let placesresult = null
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }
        map.setOptions({
          center: pos,
          zoom: 11
        })
      },
      () => {
        console.log('The geolocation service failed.')
      }
    )
  } else {
    // doesn't support Geolocation
    console.log('The geolocation is not available.')
  }

  return {
    id,
    options,
    map,
    googleMap,
    x,
    polygon,
    address,
    placesresult,
    markers: [],
    polygonBounder: null, // polygon
    isPolygonDrawing: false, // disabled start button in polygon UI
    polygonAddress: {}, // for commit address information in vuex
    allPolygons: [],
    terraDraw: null,
    stopTerraDraw () {
      if (!this.terraDraw) {
        return
      }
      try {
        this.terraDraw.clear()
        this.terraDraw.stop()
      } catch (e) {
        console.warn('Failed to stop Terra Draw', e)
      }
      this.terraDraw = null
    },
    initPolygonDrawing (searchPlace) {
      if (!searchPlace) {
        return false
      }
      if (this.terraDraw) {
        return
      }

      app.$store.commit('geo/saveKey', ['isPolygonDrawing', true])
      this.startTerraDrawPolygon(searchPlace)
    },
    startTerraDrawPolygon (searchPlace) {
      const beginDrawing = () => {
        this.stopTerraDraw()

        this.terraDraw = new TerraDraw({
          adapter: new TerraDrawGoogleMapsAdapter({
            map: this.map,
            lib: google.maps,
            coordinatePrecision: 9
          }),
          modes: [
            new TerraDrawPolygonMode({
              styles: {
                fillColor: '#ff0000',
                fillOpacity: 0.2,
                outlineColor: '#f33f00',
                outlineWidth: 5
              }
            })
          ]
        })

        this.terraDraw.start()

        this.terraDraw.on('ready', () => {
          this.terraDraw.setMode('polygon')

          this.terraDraw.on('finish', (featureId, context) => {
            if (!context || context.action !== 'draw') {
              return
            }

            const feature = this.terraDraw.getSnapshot().find(f => f.id === featureId)
            if (!feature || feature.geometry.type !== 'Polygon') {
              return
            }

            const ring = feature.geometry.coordinates[0] || []
            // GeoJSON rings are closed; drop the duplicate end point to match DrawingManager paths
            const openRing = ring.length > 1 &&
              ring[0][0] === ring[ring.length - 1][0] &&
              ring[0][1] === ring[ring.length - 1][1]
              ? ring.slice(0, -1)
              : ring
            const paths = openRing.map(coord => ({
              lat: coord[1],
              lng: coord[0]
            }))

            // Convert Terra Draw GeoJSON into a native Polygon to keep existing order flow
            this.terraDraw.removeFeatures([featureId])
            setTimeout(() => {
              this.stopTerraDraw()

              const nativePolygon = new googleMap.Polygon({
                paths: paths,
                strokeColor: '#f33f00',
                strokeWeight: 5,
                strokeOpacity: 0.8,
                fillColor: '#ff0000',
                fillOpacity: 0.2,
                draggable: false,
                editable: false,
                geodesic: true,
                zIndex: 1,
                map: this.map
              })

              app.$store.commit('geo/saveKey', ['isPolygonDrawing', false])
              this.initPolygon(null, true, {
                address: searchPlace.formatted_address,
                lat: searchPlace.geometry.location.lat().toString(),
                lng: searchPlace.geometry.location.lng().toString()
              }, nativePolygon)

              if (this.map.getZoom() < 9) {
                app.$store.commit('order/cleanGeo')
                this.clearMarkers()
                this.clearPolygon()
                alert('Please Zoom in to use the polygon mapping tool.\nTo select larger geographic regions, please use a radius select, scf, ZIP code, or county selection.')
              }
            }, 0)
          })
        })
      }

      // OverlayView requires map projection (Google Maps Terra Draw adapter requirement)
      if (this.map.getProjection()) {
        beginDrawing()
      } else {
        googleMap.event.addListenerOnce(this.map, 'projection_changed', beginDrawing)
      }
    },
    initPolygon(paths, editable, polygonAddress, polygon) {
      // paths: the path of polygon, if provide polygon ,it can be null
      // editable: if ture, user can drag polygon,
      // polygonAddress, the data save in vuex,
      // polygon: the polygon

      if (polygonAddress) {
        this.polygonAddress = polygonAddress
      }

      if (polygon) {
        this.polygonBounder = polygon
      } else {
        this.polygonBounder = new googleMap.Polygon({
          paths: paths,
          strokeColor: '#f33f00',
          strokeWeight: 5,
          strokeOpacity: 0.8,
          fillColor: '#ff0000',
          fillOpacity: 0.2,
          editable: false,
          draggable: false
        })

        this.polygonBounder.setMap(this.map)
        setTimeout(() => {
          this.map.fitBounds(this.polygonBounder.getBounds()) // Don't know why need delay fit map
        }, 1)
      }
      this.allPolygons.push(this.polygonBounder)
      //disable polygon editable
      if (editable) {
        this.savePolygonAddress()
        // detail: https://stackoverflow.com/questions/15563420/polygon-coordinates-changed-edited-moved-event-google-maps-v3
        // googleMap.event.addListener(this.polygonBounder.getPath(), 'set_at', polygon => {
        //   this.savePolygonAddress()
        // })
        // googleMap.event.addListener(this.polygonBounder.getPath(), 'remove_at', polygon => {
        //   this.savePolygonAddress()
        // })
        // googleMap.event.addListener(this.polygonBounder.getPath(), 'insert_at', polygon => {
        //   this.savePolygonAddress()
        // })
      }
    },
    savePolygonAddress() {
      app.$store.dispatch('order/changeGeoType', app.$store.state.geo.geoTypes.Polygon.Code)
      let searchString = ''
      let paths = []
      paths = this.polygonBounder.getPath().getArray()
      for (let path of paths) {
        searchString += path.lng() + ':' + path.lat() + '|'
      }
      searchString = searchString + paths[0].lng() + ':' + paths[0].lat()

      if (app.$store.state.geo.allPolygonPoints.length > 0) {
        app.$store.commit('geo/saveKey', ['allPolygonPoints', app.$store.state.geo.allPolygonPoints + '@' + searchString])
      } else {
        app.$store.commit('geo/saveKey', ['allPolygonPoints', searchString])
      }
      if (app.$store.state.order.OrderAddresses.length > 0 && app.$store.state.order.OrderAddresses[0].AddrSearchString !== searchString) {
        app.$store.commit('order/cleanGeo')
      }
      app.$store.commit('order/addAddress', {
        Radius: 0,
        AddrSearchString: app.$store.state.geo.allPolygonPoints,
        AddressLine: this.polygonAddress.address,
        AddressName: this.polygonAddress.address,
        Latitude: this.polygonAddress.lat,
        Longitude: this.polygonAddress.lng
      })
      app.$store.commit('order/addGeo', {
        AddressLine: app.$store.state.geo.allPolygonPoints,
        GeoKeyCode: app.$store.state.geo.allPolygonPoints,
        GeoKeyDesc: this.polygonAddress.address,
        GeoType: app.$store.state.order.GeoType
      })
    },
    clearMarkers() {
      for (let marker of this.markers) {
        marker.setMap(null)
      }
      this.markers = []
    },
    clearPolygon() {
      this.stopTerraDraw()
      app.$store.commit('geo/saveKey', ['isPolygonDrawing', false])
      if (this.polygonBounder) {
        this.polygonBounder.setMap(null)
        this.polygonBounder = null
      }
      this.allPolygons.forEach(p => {
        p.setMap(null)
      })
      this.allPolygons = []
      app.$store.commit('geo/saveKey', ['allPolygonPoints', ''])
    },
    initCircleDrawing(orderAddresses, isMark) {
      let circleMaps = []
      if (orderAddresses.length === 0) {
        return
      }
      let bounds = new googleMap.LatLngBounds()
      for (let address of orderAddresses) {
        let circle = new googleMap.Circle({
          strokeColor: '#979797',
          strokeWeight: 1,
          strokeOpacity: 0.8,
          fillColor: '#979797',
          fillOpacity: 0.4,
          draggable: false,
          editable: false,
          geodesic: true,
          zIndex: 1,
          map: map,
          radius: address.Radius * 1609.344,
          center: { lat: Number(address.Latitude), lng: Number(address.Longitude) }
        })
        bounds.union(circle.getBounds())
        let market = null
        if (isMark) {
          market = new googleMap.Marker({
            position: { lat: Number(address.Latitude), lng: Number(address.Longitude) },
            center: { lat: Number(address.Latitude), lng: Number(address.Longitude) },
            map: map
          })
        }
        circleMaps.push({ c: circle, m: market })
      }
      setTimeout(() => {
        this.map.fitBounds(bounds)
      }, 1)
      return circleMaps
    },
    clearTextSearchMarks() {
      for (let item of this.textSearchMarks) {
        item.setMap(null)
      }
      this.textSearchMarks = []
    },
    textSearchMarks: [],
    textSearch(query, cb, clearMark) {
      let service = new googleMap.places.PlacesService(map)
      let that = this
      service.textSearch({
        query: query,
        componentRestrictions: { country: 'us' }
      }, (result, status) => {
        if (status === googleMap.places.PlacesServiceStatus.OK) {
          if (clearMark) {
            this.clearTextSearchMarks()
          }
          that.map.setCenter(result[0].geometry.location)
          that.map.setZoom(12)
          let m = new googleMap.Marker({
            position: result[0].geometry.location,
            center: result[0].geometry.location,
            map: that.map
          })
          this.textSearchMarks.push(m)
          /* eslint-disable standard/no-callback-literal */
          cb({ placesresult: result[0], marker: m })
        } else {
          cb({ placesresult: null })
        }
      })
    },
    marker(place) {
      let m = new googleMap.Marker({
        position: place,
        center: place,
        map: this.map
      })
      return m
    },
    resize() {
      googleMap.event.trigger(map, 'resize')
    },
    getAddress(query, cb) {
      let service = new googleMap.places.PlacesService(map)
      let that = this
      service.textSearch({
        query: query,
        componentRestrictions: { country: 'us' }
      }, (result, status) => {
        if (status === googleMap.places.PlacesServiceStatus.OK) {
          /* eslint-disable*/
          that.map.setCenter(result[0].geometry.location)
          that.map.setZoom(12)
          cb({
            placesresult: result[0]
          })
        }
      })
    },
    hasAddLayer: false,
    addLayer(layer_name, layer_title, isdefault) {
      layer_name = layer_name || 'ZIP'
      layer_title = layer_title || layer_name
      isdefault = isdefault || 1

      let wmsUrl = app.$store.getters['config/wmsLink'];
      let wmsLayer = this.createWMSTileLayer(wmsUrl, layer_name, null, "image/png", null, null, null, .1, map);

      let zoomLevel = map.getZoom()
      if (zoomLevel > 8) {
        this.hasAddLayer = true
        map.overlayMapTypes.setAt(0, wmsLayer)
      }
      googleMap.event.addListener(map, 'zoom_changed', () => {
        zoomLevel = map.getZoom()
        if (zoomLevel > 8 && !this.hasAddLayer) {
          this.hasAddLayer = true
          map.overlayMapTypes.setAt(0, wmsLayer)
        }

        if (zoomLevel <= 8 && this.hasAddLayer) {
          this.hasAddLayer = false
          map.overlayMapTypes.clear();
        }
      })
    },
    createWMSTileLayer(wmsUrl, wmsLayers, wmsStyles, wmsFormat, wmsVersion, wmsBgColor, wmsSrs, opacity, map) {
      return new googleMap.ImageMapType({
        getTileUrl: this.CustomGetTileUrl,
        tileSize: new googleMap.Size(256, 256),
        isPng: true,
        maxZoom: 1,
        getOpacity: 1,
        name: 'bounder',
        myLayers: wmsLayers,
        myStyles: (wmsStyles ? wmsStyles : "RedBorder"),
        myFormat: (wmsFormat ? wmsFormat : "image/png"),
        myVersion: (wmsVersion ? wmsVersion : "1.1.1"),
        myBgColor: (wmsBgColor ? wmsBgColor : "0xffffff"),
        myBaseURL: wmsUrl
      })
    },
    CustomGetTileUrl(a, b, c) {
      //cover the pixel to LatLng
      let proj = map.getProjection();
      let zfactor = Math.pow(2, b);
      let lUL = proj.fromPointToLatLng(new googleMap.Point(a.x * 256 / zfactor, (a.y + 1) * 256 / zfactor));
      let lLR = proj.fromPointToLatLng(new googleMap.Point((a.x + 1) * 256 / zfactor, a.y * 256 / zfactor));

      let lSRS = "EPSG:4326"
      let lBbox = lUL.lng() + "," + lUL.lat() + "," + lLR.lng() + "," + lLR.lat()
      let lURL = this.myBaseURL

      lURL += "&REQUEST=GetMap"
      lURL += "&SERVICE=WMS"
      lURL += "&VERSION=" + this.myVersion;
      lURL += "&LAYERS=" + this.myLayers;
      // lURL += "&STYLES=" + this.myStyles;
      lURL += "&FORMAT=" + this.myFormat;
      lURL += "&BGCOLOR=" + this.myBgColor;
      lURL += "&TRANSPARENT=TRUE"
      lURL += "&SRS=" + lSRS
      lURL += "&BBOX=" + lBbox
      lURL += "&WIDTH=256"
      lURL += "&HEIGHT=256"
      lURL += "&reaspect=false"
      return lURL
    },
    loadBoundId: [],
    loadPolygons: {},
    clearSelecteBounder() {
      for (let key of Object.keys(this.loadPolygons)) {
        for (let item of this.loadPolygons[key]) {
          item.setOptions({
            strokeOpacity: 0,
            fillOpacity: 0
          })
        }
      }
    },
    fitZipBounder() {
      let bounds = new googleMap.LatLngBounds()
      for (let item of app.$store.getters['order/geoItems']) {
        if (this.loadPolygons[item.GeoKeyCode]) { // TODO@PONY I don't why can't find 0, so I add this condition
          for (let d in this.loadPolygons[item.GeoKeyCode]) {
            bounds.union(this.loadPolygons[item.GeoKeyCode][d].getBounds())
          }
        }
      }
      if (app.$store.getters['order/geoItems'].length === 0) {
        // move to the center of USA
        // this.map.setZoom(4)
        // this.map.setCenter(new this.googleMap.LatLng(37.1, -95.7))
      } else {
        setTimeout(() => {
          this.map.fitBounds(bounds)
        })
      }
    },
    addBounder(geo, isAdded, isFitMap) {
      if (!app.$store.state.geo.catchZipBounders.hasOwnProperty(geo.id) || app.$store.state.geo.catchZipBounders[geo.id] === 'loading') {
        app.$set(app.$store.state.geo.catchZipBounders, geo.id, geo)
      }

      if (this.loadBoundId.indexOf(geo.id) > 0) {
        if (isAdded) {
          app.$store.commit('order/addGeo', {
            GeoKeyCode: geo.id,
            GeoKeyDesc: geo.id,
            GeoType: 5
          })

          for (let item of this.loadPolygons[geo.id]) {
            item.setOptions({
              fillColor: '#FF0000',
              strokeOpacity: 1,
              fillOpacity: 0.2
            })
          }
        }
        return
      }
      this.loadBoundId.push(geo.id)

      this.loadPolygons[geo.id] = []
      // for (let item of geo.data) {
      for (let d in geo.data) {
        let item = geo.data[d]  // TODO@PONY it save time
        let polygon = new googleMap.Polygon({
          path: googleMap.geometry.encoding.decodePath(item[0].encodedPoints),
          levels: item[0].encodedLevels,
          strokeColor: '#FF0000',
          strokeOpacity: 0,
          strokeWeight: 2,
          fillOpacity: 0,
          map: this.map,
          id: geo.id,
          zIndex: 1000
        })

        googleMap.event.addListener(polygon, 'click', event => {
          if (!app.$store.getters['order/hasGeoItem'](polygon.id)) {
            app.$store.commit('order/addGeo', {
              GeoKeyCode: geo.id,
              GeoKeyDesc: geo.id,
              GeoType: 5
            })

            for (let item of this.loadPolygons[polygon.id]) {
              item.setOptions({
                fillColor: '#FF0000',
                strokeOpacity: 1,
                fillOpacity: 0.4
              })
            }
          } else {
            app.$store.commit('order/deleteGeo', polygon.id)

            for (let item of this.loadPolygons[polygon.id]) {
              polygon.setOptions({
                fillColor: '#FF0000',
                strokeOpacity: 0,
                fillOpacity: 0
              })
            }
          }
        })

        this.loadPolygons[geo.id].push(polygon)
      }

      if (isAdded) {
        if (!app.$store.getters['order/hasGeoItem'](geo.id)) {
          app.$store.commit('order/addGeo', {
            GeoKeyCode: geo.id,
            GeoKeyDesc: geo.id,
            GeoType: 5
          })
        }
        for (let item of this.loadPolygons[geo.id]) {
          item.setOptions({
            fillColor: '#FF0000',
            strokeOpacity: 1,
            fillOpacity: 0.2
          })
        }
      }
      if (isFitMap) {
        this.fitZipBounder()
      }
    },
    startSelect(geoType) {
      this.map.addListener('click', event => {
        if (app.$store.state.order.GeoType !== geoType) {
          app.$store.dispatch('order/changeGeoType', geoType)
        }
        this.getXYBounder(event.latLng.lng(), event.latLng.lat(), true)
      })
    },
    getXYBounder(x, y, isAdded) {
      app.$http.get(app.$store.getters['config/mapDataLink'] + 'type=zipxy&x=' + x + '&y=' + y)
        .then(resp => {
          if (resp.body === '') {
            return
          }
          this.addBounder(resp.body, isAdded, true)
        })
    },
    getZipBounder(zip, isAdded, isFitMap) {
      if (zip.length !== 5) {
        return
      }
      let catchZipBounders = app.$store.state.geo.catchZipBounders
      if (catchZipBounders.hasOwnProperty(zip) && catchZipBounders[zip] !== 'loading') {
        this.addBounder(catchZipBounders[zip], isAdded)
        if (isFitMap) {
          this.fitZipBounder()
        }
      } else if (catchZipBounders[zip] === 'loading') {
        return
      } else {
        app.$set(app.$store.state.geo.catchZipBounders, zip, 'loading')

        app.$http.get(app.$store.getters['config/mapDataLink'] + 'type=zip&zip=' + zip)
          .then(resp => {
            if (resp.body === '') {
              return
            }
            this.addBounder(resp.body, isAdded)
            if (isFitMap) {
              this.fitZipBounder()
            }
          })
      }
    },
    updateZipBounders() {
      for (let code of Object.keys(this.loadPolygons)) {
        if (!app.$store.getters['order/hasGeoItem'](code)) {
          for (let item of this.loadPolygons[code]) {
            item.setOptions({
              strokeOpacity: 0,
              fillOpacity: 0
            })
          }
        }
      }
      for (let i = 0; i < app.$store.getters['order/geoItems'].length; i++) {
        let geo = app.$store.getters['order/geoItems'][i]
        if (geo.GeoType === 5) {
          let isExist = false
          for (let code of Object.keys(this.loadPolygons)) {
            if (geo.GeoKeyCode === code) {
              isExist = true
            }
          }
          if (!isExist) {
            this.getZipBounder(geo.GeoKeyCode, true, i === app.$store.getters['order/geoItems'].length - 1)
          }
        }
      }
    },
    getRadioBounders(x, y, r, isAdded) {
      app.$http.get(app.$store.getters['config/mapDataLink'] + 'type=radius_zip&x=' + x + '&y=' + y + '&r=' + r)
        .then(resp => {
          if (resp.body === '') {
            return
          }
          for (let geo of resp.body) {
            this.addBounder(geo, isAdded)
          }
        })
    },
    autocomplete: null,
    startZipMapAutocomplete(id) {
      this.autocomplete = new this.googleMap.places.Autocomplete(
        document.getElementById(id), {
        types: ['address'],
        componentRestrictions: { 'country': 'us' }
      }
      )
    },
    startZipAutocomplete(id, cb) {
      this.autocomplete = new this.googleMap.places.Autocomplete(
        document.getElementById(id), {
        types: ['address'],
        componentRestrictions: { 'country': 'us' }
      }
      )
      this.autocomplete.addListener('place_changed', this.autocompleteFill(id))
    },
    startPolygonAutocomplete(id, cb) {
      this.autocomplete = new this.googleMap.places.Autocomplete(
        document.getElementById(id), {
        types: ['address'],
        componentRestrictions: { 'country': 'us' }
      }
      )
      this.autocomplete.addListener('place_changed', cb)
    },
    autocompleteMark: null,
    autocompleteFill(id) {
      return () => {
        if (this.autocompleteMark) {
          this.autocompleteMark.setMap(null)
        }
        let place = this.autocomplete.getPlace()
        if (place.address_components &&
          place.address_components[0] &&
          place.address_components[0].long_name.length === 5 &&
          !isNaN(place.address_components[0].long_name)) {
          app.$store.dispatch('order/changeGeoType', this.geoType)
          this.getZipBounder(place.address_components[0].long_name, true, true)
          document.getElementById(id).value = place.address_components[0].long_name
        } else if (place.geometry) {
          this.map.setZoom(12)
          this.map.panTo(place.geometry.location)
          this.autocompleteMark = new google.maps.Marker({
            position: place.geometry.location,
            center: place.geometry.location,
            map: this.map
          })
          this.places = place
        } else {
          document.getElementById(id).placeholder = 'Enter a ZIP Code/Address'
        }
      }
    },
    drawCircle(lng, lat, radius) {
      let circle = new googleMap.Circle({
        strokeColor: '#f33f00',
        strokeWeight: 5,
        strokeOpacity: 0.8,
        fillColor: '#ff0000',
        fillOpacity: 0.2,
        draggable: false,
        editable: false,
        geodesic: true,
        zIndex: 1,
        map: map,
        radius: radius * 1609.344,
        center: { lat, lng }
      })

      map.fitBounds(circle.getBounds())
      return circle

      // var bounds = new google.maps.LatLngBounds();
      //
      // $.each(circles, function(index, circle){
      //   bounds.union(circle.getBounds());
      // });
      //
      // map.fitBounds(bounds);
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/utils/map.js